import React from 'react';

import IconArtists from '../../../components/IconArtists/IconArtists';
import IconBakery from '../../../components/IconBakery/IconBakery';
import IconCheese from '../../../components/IconCheese/IconCheese';
import IconCraftsperson from '../../../components/IconCraftsperson/IconCraftsperson';
import IconFlower from '../../../components/IconFlower/IconFlower';
import IconFood from '../../../components/IconFood/IconFood';
import IconHomeware from '../../../components/IconHomeware/IconHomeware';
import IconMeat from '../../../components/IconMeat/IconMeat';
import IconPersonalCare from '../../../components/IconPersonalCare/IconPersonalCare';
import IconShellfish from '../../../components/IconShellfish/IconShellfish';
import IconTextile from '../../../components/IconTextile/IconTextile';
import IconVegetable from '../../../components/IconVegetable/IconVegetable';
import IconVineyard from '../../../components/IconVineyard/IconVineyard';
import IconYourOwnFarm from '../../../components/IconYourOwnFarm/IconYourOwnFarm';

import IconFarmShop from '../components/IconFarmShop/IconFarmShop';
import IconLocalDeliveryBox from '../components/IconLocalDeliveryBox/IconLocalDeliveryBox';
import IconButcher from '../components/IconButcher/IconButcher';
import IconFishmonger from '../components/IconFishmonger/IconFishmonger';
import IconGreengrocer from '../components/IconGreengrocer/IconGreengrocer';
import IconLifestyleAndGiftShop from '../components/IconLifestyleAndGiftShop/IconLifestyleAndGiftShop';

import IconFarmersMarket from '../components/IconFarmersMarket/IconFarmersMarket';
import IconCraftFair from '../components/IconCraftFair/IconCraftFair';
import IconFestival from '../components/IconFestival/IconFestival';
import IconShow from '../components/IconShow/IconShow';

import IconBedBreakfast from '../components/IconBedBreakfast/IconBedBreakfast';
import IconCamping from '../components/IconCamping/IconCamping';
import IconGlamping from '../components/IconGlamping/IconGlamping';
import IconHotel from '../components/IconHotel/IconHotel';
import IconSelfCatering from '../components/IconSelfCatering/IconSelfCatering';

import IconChildFriendly from '../components/IconChildFriendly/IconChildFriendly';
import IconDogFriendly from '../components/IconDogFriendly/IconDogFriendly';
import IconWifi from '../components/IconWifi/IconWifi';

export const producerTypeIcon = {
  producer_type_artists: props => <IconArtists {...props} />,
  producer_type_bakeries: props => <IconBakery {...props} />,
  producer_type_textiles_and_wool: props => <IconTextile {...props} />,
  producer_type_cheese_dairy_eggs: props => <IconCheese {...props} />,
  producer_type_clothes_access: props => <IconCraftsperson {...props} />,
  producer_type_flowers_plants: props => <IconFlower {...props} />,
  producer_type_food_drink: props => <IconFood {...props} />,
  producer_type_fish: props => <IconShellfish {...props} />,
  producer_type_fruit_vegetables: props => <IconVegetable {...props} />,
  producer_type_homewares: props => <IconHomeware {...props} />,
  producer_type_meat_poultry_game: props => <IconMeat {...props} />,
  producer_type_pyo_farms: props => <IconYourOwnFarm {...props} />,
  producer_type_personal_care: props => <IconPersonalCare {...props} />,
  producer_type_alcohol: props => <IconVineyard {...props} />,
  producer_type_flowers_plants: props => <IconFlower {...props} />,
};

export const typeIcon = {
  'farm-shop': props => <IconFarmShop {...props} />,
  'local-delivery-box': props => <IconLocalDeliveryBox {...props} />,
  butcher: props => <IconButcher {...props} />,
  fishmonger: props => <IconFishmonger {...props} />,
  greengrocer: props => <IconGreengrocer {...props} />,
  'lifestyle-gift-shop': props => <IconLifestyleAndGiftShop {...props} />,
};

export const marketsAndEventsIcon = {
  'farmers-market': props => <IconFarmersMarket {...props} />,
  'craft-fair': props => <IconCraftFair {...props} />,
  festival: props => <IconFestival {...props} />,
  show: props => <IconShow {...props} />,
};

export const producersPlacesIcon = {
  bed_breakfast: props => <IconBedBreakfast {...props} />,
  campsite: props => <IconCamping {...props} />,
  glamping: props => <IconGlamping {...props} />,
  inn_hotel: props => <IconHotel {...props} />,
  self_catering: props => <IconSelfCatering {...props} />,
};

export const featuresIcon = {
  child_friendly: props => <IconChildFriendly {...props} />,
  'dog-friendly': props => <IconDogFriendly {...props} />,
  wifi: props => <IconWifi {...props} />,
};
